import React from 'react';
import { Section } from './ui/Section';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  const scrollToPricing = () => {
    trackEvent('ViewContent', {
      content_name: 'final_cta_click',
      content_category: 'cta'
    });
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <Section data-id="element-73">
      <div className="text-center max-w-3xl mx-auto" data-id="element-74">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-6 text-brand-title" data-id="element-75">
          Solo hay dos tipos de instructores...
        </h2>

        <p className="text-xl text-brand-subtitle mb-4" data-id="element-76">
          Los que siguen improvisando cada domingo...
        </p>

        <p className="text-xl text-brand-title font-semibold mb-8" data-id="element-77">
          Y los que ya están usando el Manual PRO para disfrutar de sus clases y
          de su tiempo libre.
        </p>

        <p className="text-2xl font-display font-bold text-brand-title mb-6" data-id="element-78">
          ¿En qué grupo quieres estar tú mañana?
        </p>

        <div className="bg-white border-2 border-brand-cta rounded-2xl p-6 shadow-red-glow-lg mb-6" data-id="element-79">
          <div className="text-sm text-brand-textMuted uppercase tracking-wider mb-2" data-id="element-80"></div>
          <button onClick={scrollToPricing} className="bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-10 rounded-btn transition-all hover:scale-105 active:scale-95 shadow-red-glow-lg w-full md:w-auto tracking-wide" data-id="element-81">
            🚀 SÍ, QUIERO MI TIEMPO DE VUELTA →
          </button>
        </div>

        <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-82">
          ⚡ Acceso Inmediato • 🛡️ Garantía de 7 Días • 💳 Pago Único
        </div>
      </div>
    </Section>;
}